import React from 'react';
import styled from '@emotion/styled';
import PageHeader from '../components/PageHeader';

const CopyrightContainer = styled.div`
  padding: 2rem;
  max-width: 1000px;
  margin: 0 auto;
  
  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

const ContentSection = styled.div`
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(10px);
  padding: 2rem;
  border-radius: 15px;
  border: 2px solid rgba(255, 51, 51, 0.3);
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 2rem;
  
  @media (max-width: 768px) {
    padding: 1.5rem;
  }
  
  h2 {
    color: #ff3333;
    margin-top: 2rem;
    margin-bottom: 1rem;
    font-size: 1.8rem;
    
    &:first-of-type {
      margin-top: 0;
    }
  }
  
  p {
    line-height: 1.7;
    margin-bottom: 1rem;
    font-size: 1.1rem;
  }

  ul, ol {
    margin-bottom: 1.5rem;
    padding-left: 1.5rem;
    
    li {
      margin-bottom: 0.5rem;
      line-height: 1.6;
    }
  }
`;



const CopyrightNotice = () => {
  return (
    <>
      <PageHeader title="Copyright Notice" highlightWord="Notice" />
      <CopyrightContainer>
        <ContentSection>
          <p>&copy; {new Date().getFullYear()} <span>Red<span style={{ color: '#ff3333' }}>Cloud</span> Storage</span>. All rights reserved.</p>
          
          <p>All content, graphics, logos, and software provided on this website are the intellectual property of <span>Red<span style={{ color: '#ff3333' }}>Cloud</span> Storage</span>, unless otherwise stated. Unauthorized reproduction, distribution, or modification of any material on this site is strictly prohibited without prior written consent.</p>
          
          <p>Use of this site does not grant you any rights to our intellectual property. Trademarks, logos, or names of third parties (including Nextcloud) are the property of their respective owners.</p>
          
          <p>For permissions or inquiries, contact: <a style={{ color: '#ff3333', textDecoration: 'none' }} href="mailto:support@redcloudstorage.net">support@redcloudstorage.net</a></p>
        </ContentSection>
      </CopyrightContainer>
    </>
  );
};

export default CopyrightNotice;
